import { observable, action } from 'mobx';
import config from 'config';
import HttpClient from 'utils/httpclient';
import { LOADING, LOADED } from 'stores/BaseStore';

class ReportsAuditStore {
  @observable data = null;
  @observable status = LOADED;

  @action getAudit (queryParams) {
    this.status = LOADING;
    let params = Object.assign({}, queryParams);
    return HttpClient.get(`${config.api}/reports/audit`, { params })
      .then(response => {
        this.data = response.data;
        return response;
      }).finally(() => this.status = LOADED);
  }
}

export default new ReportsAuditStore();
